export const SESSION_STORAGE_TYPE = {
  batched: 'BATCHED_ANALYTICS_',
  priority: 'PRIORITY_ANALYTICS_',
};

export const GODAVARI_EVENT_TYPE = {
  BATCHED: 'batched',
  PRIORITY: 'priority',
};

export const SESSION_KEY_STORAGE_TYPE = {
  batched: 'BATCHED_ANALYTICS_KEY_LISTS',
  priority: 'PRIORITY_ANALYTICS_KEY_LISTS',
};

export const HISTORY_NETWORK_CAPTURE = {
  GODAVARI_PREPROD: 'godavari2-dev.slivinternal.com',
  GODAVARI_PROD: 'evt.sonyliv.com',
  // GOOGLE: 'analytics.google.com',
  GOOGLE_TV: 'www.google-analytics.com',
  GOOGLE_TV2: 'google-analytics.com',
};

export const NETWORK_URL_TYPE = {
  priority: 'priority/records',
  batched: 'batched/records',
  google: 'google',
};

export const NETWORK_TYPE = {
  priority: 'priority',
  batched: 'batched',
  google: 'google',
};

export const UNKNOWN_STATE = 'unknown';

export const MAIN_NETWORK_LOG_WRAPPER = 'mainNetworkLogWrapper';
export const FOOTER_NETWORK_LOG_WRAPPER = 'footerNetworkLogWrapper';
export const NETWORK_RECORDING_ON = 'recordingOn';
export const NETWORK_RECORDING_OFF = 'recordingOff';
export const NETWORK_DOWNLOAD_SNAPSHOT = 'snapShot';
export const NETWORK_RECORDING_START = 'historyRecordingStart';
export const NETWORK_RESET_MODE = 'historyResetMode';

export const EVENTS = {
  click: 'click',
  mousemove: 'mousemove',
  mousedown: 'mousedown',
  mouseup: 'mouseup',
  mouseleave: 'mouseleave',
  wheel: 'wheel',
  mouseenter: 'mouseenter',
};

//dashboard keys
export const GV_EXTRA_PARAMS = {
  GvClientId: 'GvClientId',
  SessionId: 'SessionId',
  timestamp: 'timestamp',
  sessionDuration: 'sessionDuration',
  pageDuration: 'pageDuration',
  event_type: 'event_type',
  SessionDuration: 'SessionDuration',
  PreviousScreenTime: 'PreviousScreenTime',
  SdkVersion: 'SdkVersion',
  DeviceBrand: 'DeviceBrand',
  DeviceCategory: 'DeviceCategory',
  IpAddress: 'IpAddress',
  UserAgent: 'UserAgent',
  TimeZone: 'TimeZone',
  event_id: 'event_id',
  batch_id: 'batch_id',
};
export const GV_USER_PROPERTIES = {
  // new keys
  DeviceBrand: 'DeviceBrand',
  DeviceCategory: 'DeviceCategory',
  IpAddress: 'IpAddress',
  UserAgent: 'UserAgent',
  TimeZone: 'TimeZone',
  SessionId: 'SessionId',
  Age: 'Age',
  AppName: 'AppName',
  AppsFlyerID: 'AppsFlyerID',
  AppVersion: 'AppVersion',
  AspectRatio: 'AspectRatio',
  AVSPlatform: 'AVSPlatform',
  campaign_id: 'campaign_id',
  CastingReceiver: 'CastingReceiver',
  ChromeCast: 'ChromeCast',
  Country: 'Country',
  countryCode: 'countryCode',
  ct_objectId: 'ct_objectId',
  dclid: 'dclid',
  defaultLocale: 'defaultLocale',
  favoriteCount: 'favoriteCount',
  first_open_time: 'first_open_time',
  ga_session_id: 'ga_session_id',
  ga_session_number: 'ga_session_number',
  gad_source: 'gad_source',
  gclid: 'gclid',
  internetConnectType: 'internetConnectType',
  is_africa_country: 'is_africa_country',
  is_gdpr_country: 'is_gdpr_country',
  IsAfricaCountry: 'IsAfricaCountry',
  IsAgeConsent: 'IsAgeConsent',
  is_caribbean_country: 'is_caribbean_country',
  IsGDPRCountry: 'IsGDPRCountry',
  last_gclid: 'last_gclid',
  launchCount: 'launchCount',
  LoggedInLedi: 'LoggedInLedi',
  NetworkSpeedBucket: 'NetworkSpeedBucket',
  NoOfProfilePresent: 'NoOfProfilePresent',
  prevenue_28d: 'prevenue_28d',
  previous_app_version: 'previous_app_version',
  price: 'price',
  product_id: 'product_id',
  push_reachability: 'push_reachability',
  RegionCode: 'RegionCode',
  shorts_audience: 'shorts_audience',
  shorts_ios_audience: 'shorts_ios_audience',
  sti_audience: 'sti_audience',
  subscription: 'subscription',
  // old keys
  GvClientId: 'GvClientId',
  AdvertiserID: 'AdvertiserID',
  PPID: 'PPID',
  LivID: 'LivID',
  CleverTapID: 'CleverTapID',
  ClientID: 'ClientID',
  Platform: 'Platform',
  DeviceName: 'DeviceName',
  UserType: 'UserType',
  CPID: 'CPID',
  DateOfBirth: 'DateOfBirth',
  LoggedInMedium: 'LoggedInMedium',
  SubscriptionStatus: 'SubscriptionStatus',
  SubscribedPackSKU: 'SubscribedPackSKU',
  UserAge: 'UserAge',
  UserGender: 'UserGender',
  MultiProfileCategory: 'MultiProfileCategory',
  ProfileNumber: 'ProfileNumber',
  NoOfProfilesPresent: 'NoOfProfilesPresent',
  MultiProfileType: 'MultiProfileType',
  SegmentID: 'SegmentID',
  IsUpdatedSchema: 'IsUpdatedSchema',
  IsReferral: 'IsReferral',
  KidProfile: 'KidProfile',
  SdkVersion: 'SdkVersion',
  DeviceModel: 'DeviceModel',
  OSVersion: 'OSVersion',
  OperatingSystem: 'OperatingSystem',
};

export const GV_EVENT_DATA_LIST = {
  items: 'items',
  sessionId: 'sessionId',
  AdCampaignID: 'AdCampaignID',
  AdClass: 'AdClass',
  AdDuration: 'AdDuration',
  AdFormat: 'AdFormat',
  AdPlaybackID: 'AdPlaybackID',
  AdSessionID: 'AdSessionID',
  AdSupport: 'AdSupport',
  AdTag: 'AdTag',
  AgeBucket: 'AgeBucket',
  AgeClassification: 'AgeClassification',
  AppRating: 'AppRating',
  AssetLayout: 'AssetLayout',
  AssetSubType: 'AssetSubType',
  AssetTitle: 'AssetTitle',
  AssetType: 'AssetType',
  AutoPlayedDuration: 'AutoPlayedDuration',
  Autopay: 'Autopay',
  AvatarSelected: 'AvatarSelected',
  AvatarSelectedName: 'AvatarSelectedName',
  Brand: 'Brand',
  BroadcastChannel: 'BroadcastChannel',
  BusinessUnit: 'BusinessUnit',
  ButtonText: 'ButtonText',
  CACTag: 'CACTag',
  CampaignName: 'CampaignName',
  ChromecastDeviceName: 'ChromecastDeviceName',
  City: 'City',
  CollectionID: 'CollectionID',
  Company: 'Company',
  CompletionRate: 'CompletionRate',
  ConnectionType: 'ConnectionType',
  ContentID: 'ContentID',
  ControlsInvoked: 'ControlsInvoked',
  ControlsInvokedThrough: 'ControlsInvokedThrough',
  CorrectAnswer: 'CorrectAnswer',
  Count: 'Count',
  CouponCategory: 'CouponCategory',
  CouponCodeName: 'CouponCodeName',
  CreativeID: 'CreativeID',
  DescriptionState: 'DescriptionState',
  Device: 'Device',
  DeviceManufacturer: 'DeviceManufacturer',
  DownloadBitrate: 'DownloadBitrate',
  DownloadQuality: 'DownloadQuality',
  DownloadSize: 'DownloadSize',
  DurationBucket: 'DurationBucket',
  EndDate: 'EndDate',
  EntryPoint: 'EntryPoint',
  EpisodeNumber: 'EpisodeNumber',
  ErrorID: 'ErrorID',
  ErrorText: 'ErrorText',
  ErrorType: 'ErrorType',
  EventName: 'EventName',
  FilterCategory: 'FilterCategory',
  FilterRangeType: 'FilterRangeType',
  FilterValue: 'FilterValue',
  FormType: 'FormType',
  GameID: 'GameID',
  GameName: 'GameName',
  HorizontalPosition: 'HorizontalPosition',
  IconState: 'IconState',
  IncentiveType: 'IncentiveType',
  IndirectEntryPoint: 'IndirectEntryPoint',
  InvitationCode: 'InvitationCode',
  IsAutoPlayed: 'IsAutoPlayed',
  IsGame: 'IsGame',
  IssueCategory: 'IssueCategory',
  IssueType: 'IssueType',
  KBCChannelID: 'KBCChannelID',
  KBCProgramID: 'KBCProgramID',
  KBCProgramName: 'KBCProgramName',
  KBCTotalSeasonQuestions: 'KBCTotalSeasonQuestions',
  KBCUserPoints: 'KBCUserPoints',
  KBCUserRank: 'KBCUserRank',
  Keyword: 'Keyword',
  LeagueCode: 'LeagueCode',
  LogInFlow: 'LogInFlow',
  LogInType: 'LogInType',
  MarkerName: 'MarkerName',
  MarkerType: 'MarkerType',
  MatchID: 'MatchID',
  TourID: 'TourID',
  MaxAdDurationRequest: 'MaxAdDurationRequest',
  NewValue: 'NewValue',
  NoOfAdsRequest: 'NoOfAdsRequest',
  NumberOfDevices: 'NumberOfDevices',
  OfferType: 'OfferType',
  OfflineMode: 'OfflineMode',
  OrientationOfPlayback: 'OrientationOfPlayback',
  PackName: 'PackName',
  PackPrice: 'PackPrice',
  PageCategory: 'PageCategory',
  PageID: 'PageID',
  ParameterUpdated: 'ParameterUpdated',
  ParentalControlSet: 'ParentalControlSet',
  PaymentMethod: 'PaymentMethod',
  PaymentMethodSection: 'PaymentMethodSection',
  PlaybackLanguage: 'PlaybackLanguage',
  PlayerMode: 'PlayerMode',
  PopUpTitle: 'PopUpTitle',
  PopularCategory: 'PopularCategory',
  PreferenceTitle: 'PreferenceTitle',
  PreviewDuration: 'PreviewDuration',
  PreviewLength: 'PreviewLength',
  PreviewThumbnailLoad: 'PreviewThumbnailLoad',
  PreviewVideoStart: 'PreviewVideoStart',
  PreviewVideoView: 'PreviewVideoView',
  PreviewWatchTime: 'PreviewWatchTime',
  PreviousScreen: 'PreviousScreen',
  PreviousScreenTime: 'PreviousScreenTime',
  PreviousValue: 'PreviousValue',
  ProductSKUName: 'ProductSKUName',
  ProfileName: 'ProfileName',
  Province: 'Province',
  QuestionNumber: 'QuestionNumber',
  QuestionType: 'QuestionType',
  QuizType: 'QuizType',
  RecoSource: 'RecoSource',
  ReferralCode: 'ReferralCode',
  ResultType: 'ResultType',
  SavedPaymentMode: 'SavedPaymentMode',
  ScreenName: 'ScreenName',
  ScreenNameContent: 'ScreenNameContent',
  SearchName: 'SearchName',
  SearchType: 'SearchType',
  SeasonNumber: 'SeasonNumber',
  SelectionType: 'SelectionType',
  ShareMode: 'ShareMode',
  ShareTo: 'ShareTo',
  ShowName: 'ShowName',
  SonyMatchID: 'SonyMatchID',
  SourceElement: 'SourceElement',
  SportID: 'SportID',
  StartDateTime: 'StartDateTime',
  State: 'State',
  StreamID: 'StreamID',
  SubscriptionDuration: 'SubscriptionDuration',
  Subtitle: 'Subtitle',
  SurveyType: 'SurveyType',
  TargetPageID: 'TargetPageID',
  TeamCode: 'TeamCode',
  TimeStamp: 'TimeStamp',
  TimeTakeToLoadVideo: 'TimeTakeToLoadVideo',
  TimeToLoadPlayer: 'TimeToLoadPlayer',
  TlMarker: 'TlMarker',
  TournamentID: 'TournamentID',
  TournamentName: 'TournamentName',
  TrayID: 'TrayID',
  TrialDuration: 'TrialDuration',
  Type: 'Type',
  TypeOfBusiness: 'TypeOfBusiness',
  UserBandwidth: 'UserBandwidth',
  UserWaitTime: 'UserWaitTime',
  Usercluster: 'Usercluster',
  VerticalPosition: 'VerticalPosition',
  VideoAdTimePosition: 'VideoAdTimePosition',
  VideoAdType: 'VideoAdType',
  VideoCategory: 'VideoCategory',
  VideoGenre: 'VideoGenre',
  VideoLanguage: 'VideoLanguage',
  VideoLength: 'VideoLength',
  VideoPrefetched: 'VideoPrefetched',
  VideoQuality: 'VideoQuality',
  VideoSessionID: 'VideoSessionID',
  VideoStart: 'VideoStart',
  VideoSubType: 'VideoSubType',
  VideoTitle: 'VideoTitle',
  VideoValue: 'VideoValue',
  VideoViewType: 'VideoViewType',
  VideoView: 'VideoView',
  WatchTime: 'WatchTime',
  event: 'event',
  eventAction: 'eventAction',
  eventCategory: 'eventCategory',
  eventLabel: 'eventLabel',
  isCasting: 'isCasting',
  scrubbingDuration: 'scrubbingDuration',
  UTMDetails: 'UTMDetails',
  AdPlayTime: 'AdPlayTime',
  Language: 'Language',
  DefaultWidgetSelected: 'DefaultWidgetSelected',
  SourceTrigger: 'SourceTrigger',
  // new key
  affiliation: 'affiliation',
  allCookiesAccepted: 'allCookiesAccepted',
  ApplicationType: 'ApplicationType',
  AvailableSpace: 'AvailableSpace',
  AVSPlatformQuality: 'AVSPlatformQuality',
  AVSVideoViewTypeQuality: 'AVSVideoViewTypeQuality',
  batch_ordering_id: 'batch_ordering_id',
  batch_page_id: 'batch_page_id',
  bitRate: 'bitRate',
  Branding: 'Branding',
  CachingByteDownload: 'CachingByteDownload',
  CachingLevel: 'CachingLevel',
  CancellationDate: 'CancellationDate',
  CancellationReasonLevelOne: 'CancellationReasonLevelOne',
  CancellationReasonLevelTwo: 'CancellationReasonLevelTwo',
  channel: 'channel',
  ChromeCastPlayback: 'ChromeCastPlayback',
  click_timestamp: 'click_timestamp',
  contentPrefetched: 'contentPrefetched',
  coupon: 'coupon',
  CouponDetails: 'CouponDetails',
  CTAClicked: 'CTAClicked',
  debug_event: 'debug_event',
  debug_mode: 'debug_mode',
  deeplinkUrl: 'deeplinkUrl',
  DefaultTabSelected: 'DefaultTabSelected',
  DownloadExpired: 'DownloadExpired',
  DownloadMethod: 'DownloadMethod',
  DownloadType: 'DownloadType',
  ElapsedTime: 'ElapsedTime',
  engaged_session_event: 'engaged_session_event',
  engagement_time_msec: 'engagement_time_msec',
  entrances: 'entrances',
  ExternalID: 'ExternalID',
  fatal: 'fatal',
  file_extension: 'file_extension',
  file_name: 'file_name',
  firebase_conversion: 'firebase_conversion',
  firebase_error: 'firebase_error',
  firebase_event_origin: 'firebase_event_origin',
  firebase_previous_class: 'firebase_previous_class',
  firebase_previous_id: 'firebase_previous_id',
  firebase_screen_class: 'firebase_screen_class',
  firebase_screen_id: 'firebase_screen_id',
  GodavariSessionID: 'GodavariSessionID',
  ignore_referrer: 'ignore_referrer',
  IMDBRating: 'IMDBRating',
  InteractivityType: 'InteractivityType',
  is_child_profile_consent: 'is_child_profile_consent',
  is_UA: 'is_UA',
  IsAgeCookie: 'IsAgeCookie',
  IsEncrypted: 'IsEncrypted',
  IsEssentialCookie: 'IsEssentialCookie',
  IsProfilingCookie: 'IsProfilingCookie',
  isProtected: 'isProtected',
  IsSessionCookie: 'IsSessionCookie',
  IssuePlatform: 'IssuePlatform',
  item_list: 'item_list',
  label: 'label',
  LastBroadcastDate: 'LastBroadcastDate',
  launch_type: 'launch_type',
  link_classes: 'link_classes',
  link_domain: 'link_domain',
  link_id: 'link_id',
  link_text: 'link_text',
  load_time: 'load_time',
  logic: 'logic',
  medium: 'medium',
  message_type: 'message_type',
  MigratedDownload: 'MigratedDownload',
  MultiCamera: 'MultiCamera',
  NetworkSource: 'NetworkSource',
  NetworkStatus: 'NetworkStatus',
  OriginalAirDate: 'OriginalAirDate',
  outbound: 'outbound',
  PackExpiry: 'PackExpiry',
  PackType: 'PackType',
  page_location: 'page_location',
  page_name: 'page_name',
  page_referrer: 'page_referrer',
  page_title: 'page_title',
  PageType: 'PageType',
  parentId: 'parentId',
  parentSubType: 'parentSubType',
  parentType: 'parentType',
  PartnerName: 'PartnerName',
  PaymentMode: 'PaymentMode',
  percent_scrolled: 'percent_scrolled',
  PreviewThumbnailLoaded: 'PreviewThumbnailLoaded',
  previous_os_version: 'previous_os_version',
  product_name: 'product_name',
  quantity: 'quantity',
  query_id: 'query_id',
  Reco: 'Reco',
  ScreenPageLoadTime: 'ScreenPageLoadTime',
  search_term: 'search_term',
  secs_of_buffer: 'secs_of_buffer',
  session_engaged: 'session_engaged',
  SessionDuration: 'SessionDuration',
  SessionID: 'SessionID',
  shipping: 'shipping',
  ShortID: 'ShortID',
  ShortsSessionId: 'ShortsSessionId',
  ShortsWatchTime: 'ShortsWatchTime',
  ShowID: 'ShowID',
  ShowTitle: 'ShowTitle',
  source_play: 'source_play',
  Sponsor: 'Sponsor',
  StackID: 'StackID',
  StartDate: 'StartDate',
  SubscriptionRevenue: 'SubscriptionRevenue',
  TataWatchTime: 'TataWatchTime',
  tax: 'tax',
  Teams: 'Teams',
  Time_taken_to_start_ad: 'Time_taken_to_start_ad',
  time_to_load_player: 'time_to_load_player',
  TimelineMarker: 'TimelineMarker',
  TimeLineMarkerName: 'TimeLineMarkerName',
  TimeLineMarkerType: 'TimeLineMarkerType',
  TimeToLoadPlayerInteractivityType: 'TimeToLoadPlayerInteractivityType',
  TimingCategory: 'TimingCategory',
  TimingLabel: 'TimingLabel',
  TimingSpeed: 'TimingSpeed',
  TimingVariable: 'TimingVariable',
  TourName: 'TourName',
  TournamentIDSports: 'TournamentIDSports',
  TrailDuration: 'TrailDuration',
  transaction_id: 'transaction_id',
  trayName: 'trayName',
  unique_search_term: 'unique_search_term',
  user_points: 'user_points',
  user_rank: 'user_rank',
  utc: 'utc',
  utt: 'utt',
  utv: 'utv',
  UXCam_links: 'UXCam_links',
  value: 'value',
  video_quality_subscribe_click: 'video_quality_subscribe_click',
  VideoAdCategory: 'VideoAdCategory',
  VideoAdPointonTimelineMillisecond: 'VideoAdPointonTimelineMillisecond',
  VideoClassification: 'VideoClassification',
  videoFreePreviewLength: 'videoFreePreviewLength',
  VideoId: 'VideoId',
  VideoRating: 'VideoRating',
  videoStopLocation: 'videoStopLocation',
  VideoSubCategory: 'VideoSubCategory',
  widgets: 'widgets',
  ManualSessionID: 'ManualSessionID',
};

//top level
export const GV_UNIQUE_PARAM_LIST = {
  sessionId: 'sessionId',
  timestamp: 'timestamp',
  event_type: 'event_type',
  event_category: 'event_category',
  event_name: 'event_name',
  panel_event_id: 'panel_event_id',
  event_id: 'event_id',
  pageDuration: 'pageDuration',
  sessionDuration: 'sessionDuration',
};

export const GA_EVENTS_IGNORE_LIST = [
  'gtm.start',
  'gtm.load',
  'gtm.click',
  'gtm.dom',
  'gtm.js',
  'gtm.linkClick',
  'gtm.historyChange',
  'gtm.historyChange-v2',
  'manual_clean_up',
];

export const SESSION_DATA_EVENTS_LIST = [
  'screenview_manual',
  'pageview_manual',
  'app_navigation',
  'app_exception',
  'view_item_list',
];
